<mat-toolbar>
  <div class="container platform-header-inner">
    @if (logoUrl) {
      <div class="platform-brand">
        <a class="navbar-brand position-relative" [routerLink]="homepageUrl | async" [attr.title]="title || '1Campus'">
          <img class="logo" [src]="logoUrl" style="height: 40px;" alt="1Campus">
          <span class="dev-mode-text" [hidden]="isProduction">開發者模式</span>
        </a>
        <span class="title" [attr.title]="title">{{title}}</span>
      </div>
    }

    <div class="platform-header-actions">
      <app-role-selector></app-role-selector>
      <app-account-setting class="d-flex align-items-center"></app-account-setting>
    </div>
  </div>
</mat-toolbar>
